<template>
  <v-app class="grey lighten-4">
    <Feedback :timeout="6000" />
    <NavBar v-if="(currentPage !== 'Login' && currentPage !== 'Reset' && currentPage !== 'Confirm Reset' && currentPage !== 'Status' && currentPage !== 'Loading' && currentPage !== 'Pipeline - Pricing Table' && currentPage !== 'Pipeline - Override Credits')"/>
    <v-main :class="{'main': showGradient}">
      <v-sheet :class="{'main': showGradient}">
        <router-view />
      </v-sheet>
    </v-main>
  </v-app>
</template>

<script>
import Feedback from '@/components/utilitycomps/Feedback.vue';
import NavBar from '@/components/navcomps/NavBar';
import { mapActions } from 'vuex';


export default {
  methods:{
    ...mapActions(['AutoLogin']),
     
  },
  mounted () {
    this.AutoLogin();
  },
  name: 'App',
  components: { NavBar, Feedback  },
  computed: {
    currentPage() {
      if (this.$route.meta.title !== null && this.$route.meta.title !== undefined){
           return this.$route.meta.title;
      }
      return 'Loading';
    },
    showGradient() {
      if (
        
          this.$route.meta.title === 'Login' || 
          this.$route.meta.title === 'Reset' || 
          this.$route.meta.title === 'Confirm Reset' || 
          (this.$route.meta.title === 'Dashboard' && (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm')
        
        )
        ){
        return true;
      }
      return false;
    }
    
  }
  
};
</script>
<style type="text/css">
  .v-icon notranslate mdi mdi-chevron-down{
    color: white;
  }
  .main {
      height: 100vh;
      background: radial-gradient(#505CBE, #282E5F) !important;
  }
</style>
